module.exports = __webpack_public_path__ + "img/gesture_zero.06ee8b47.png";